import React from 'react';

const SvgDownload = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M10 2v9H6l6 6 6-6h-4V2h-4zM2 20v2h20v-2H2z" />
  </svg>
);

export default SvgDownload;
